// ── TrainingStats.jsx ─────────────────────────────────────────────────────────
// FIXES:
//  - shimmer animation uses will-change: transform
//  - 2-col mobile layout has correct alternating borders (odd keeps right border)
import { STATS } from "./data/trainingData";

export const STATS_CSS = `
  .tp-stats {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid var(--tp-line);
    border-bottom: 1px solid var(--tp-line);
    background: linear-gradient(180deg, var(--tp-surface) 0%, var(--tp-bg) 100%);
    position: relative;
    overflow: hidden;
    contain: layout style;
  }
  .tp-stats::before {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent, rgba(77,127,255,.03) 50%, transparent);
    animation: tp-shimmer 5s ease-in-out infinite;
    will-change: transform;
  }
  .tp-stat {
    padding: 2.25rem 1.5rem;
    text-align: center;
    border-right: 1px solid var(--tp-line);
    transition: background .22s;
    position: relative;
    cursor: default;
  }
  .tp-stat:last-child { border-right: none; }
  .tp-stat:hover { background: rgba(77,127,255,.04); }
  .tp-stat:hover .tp-stat-n { color: var(--tp-blue); }
  .tp-stat::after {
    content: '';
    position: absolute;
    bottom: 0; left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: 60%; height: 2px;
    background: linear-gradient(90deg, transparent, var(--tp-blue), transparent);
    transition: transform .3s;
  }
  .tp-stat:hover::after { transform: translateX(-50%) scaleX(1); }
  .tp-stat-n {
    font-family: var(--tp-display);
    font-size: 2.1rem;
    font-weight: 700;
    color: var(--tp-t1);
    line-height: 1;
    transition: color .22s;
    letter-spacing: -.04em;
  }
  .tp-stat-l {
    font-size: .62rem;
    color: var(--tp-t3);
    margin-top: 7px;
    text-transform: uppercase;
    letter-spacing: .14em;
    font-weight: 700;
  }

  /* Responsive — tokens handle the grid switch but we fix borders here */
  @media (max-width: 900px) {
    .tp-stats { grid-template-columns: repeat(3, 1fr); }
    .tp-stat  { border-right: 1px solid var(--tp-line); }
    .tp-stat:nth-child(3n) { border-right: none; }
  }
  @media (max-width: 640px) {
    .tp-stats { grid-template-columns: repeat(2, 1fr); }
    .tp-stat  { border-right: none; border-bottom: 1px solid var(--tp-line); }
    .tp-stat:nth-child(odd)  { border-right: 1px solid var(--tp-line); }
    .tp-stat-n { font-size: 1.75rem; }
    .tp-stat   { padding: 1.75rem 1rem; }
  }
`;

export default function TrainingStats() {
  return (
    <div className="tp-stats">
      {STATS.map(([n, l]) => (
        <div key={l} className="tp-stat">
          <div className="tp-stat-n">{n}</div>
          <div className="tp-stat-l">{l}</div>
        </div>
      ))}
    </div>
  );
}
